var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.forecast)?_c('div',[_c('v-icon',{attrs:{"x-small":""}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticStyle:{"color":"grey","font-size":"10px"}},[_vm._v(_vm._s(_vm.temp_min)+"° / "+_vm._s(_vm.temp_max)+"°")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }